import { render, staticRenderFns } from "./salesSelectedItems.vue?vue&type=template&id=9bcab2b4&"
import script from "./salesSelectedItems.vue?vue&type=script&lang=js&"
export * from "./salesSelectedItems.vue?vue&type=script&lang=js&"
import style0 from "./salesSelectedItems.vue?vue&type=style&index=0&id=9bcab2b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports